'use strict';

var React = require('react');

var useOutsideClick = function (onClickOutside, _a) {
    var _b = _a === void 0 ? {} : _a, providedRef = _b.ref, _c = _b.propagateOutsideClicks, propagateOutsideClicks = _c === void 0 ? false : _c, _d = _b.isEnabled, isEnabled = _d === void 0 ? true : _d;
    var fallbackRef = React.useRef(null);
    var ref = providedRef || fallbackRef;
    React.useEffect(function () {
        var handleClickOutside = function (event) {
            if (ref.current && event.target && !ref.current.contains(event.target)) {
                if (!propagateOutsideClicks) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                onClickOutside(event);
            }
        };
        if (!isEnabled) {
            return undefined;
        }
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [isEnabled]);
    return ref;
};

exports.useOutsideClick = useOutsideClick;
//# sourceMappingURL=useOutsideClick-531afbb5.js.map
